import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';
import publicPath from '../../utils/publicPath';

export default () => {
  const { breakpoints, colors, fluidTypeScale, spacing } = useTheme();

  return {
    base: css`
      margin-top: 2.5rem;
      height: 100%;
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(298px, 1fr));
      &.contactMap {
        margin-top: 40px;
        ${breakpoints.mm_xl_xxl} {
          margin-top: 40px;
        }
        ${breakpoints.mm_l_xl} {
          margin-top: 40px;
        }
        ${breakpoints.mm_m_l} {
          margin-top: 50px;
        }
        ${breakpoints.mm_s_m} {
          grid-template-columns: none;
          margin-top: 50px;
        }
        ${breakpoints.mm_xs_s} {
          margin-top: 50px;
        }
      }
    `,
    map: css`
      margin-top: -20px;
      min-height: 200px;
      max-height: 200px;

      ${breakpoints.m} {
        min-height: 200px;
        max-height: 200px;
      }
    `,
    address: css`
      font-family: 'FS Dillon Bold' !important;
      letter-spacing: 0.08em;
      font-size: ${fluidTypeScale.font15_15} !important;
      font-weight: 700 !important;
      color: ${colors.navy};
      ${breakpoints.mm_m_l} {
        margin: 12px auto 8px;
      }
      ${breakpoints.mm_s_m} {
        margin: 12px auto 8px;
      }
      ${breakpoints.mm_xs_s} {
        margin: 12px auto 8px;
      }
    `,
    contactAddress: css`
      font-size: ${fluidTypeScale.font16_16};
      color: ${colors.next_grey};
      text-transform: capitalize;
      ${breakpoints.mm_m_l} {
        margin: 0 auto 15px;
      }
    `,
    sectionTitle: css`
      padding-bottom: 1.5rem;
      color: ${colors.navy};
      text-transform: capitalize;
      font-size: 24px;
      line-height: 26px;
      font-family: 'FS Dillon Bold' !important;

      ${breakpoints.l} {
        font-size: 35.54px;
        line-height: 40px;
        margin-bottom: 10px;
      }
      ${breakpoints.mm_m_l} {
        font-size: 25.9px;
        margin-bottom: 20px;
      }
      ${breakpoints.mm_s_m} {
        font-size: 25.9px;
        margin-bottom: 20px;
      }
      ${breakpoints.mm_xs_s} {
        font-size: 25.9px;
        margin-bottom: 20px;
      }
    `,
    link: css`
      // background: url(${publicPath('/images/mobile/club/map-placeholder.jpg')}) 0 0 no-repeat;
      background-size: contain;
      min-height: 154px;
      max-height: 154px;
      padding: 0;

      ${breakpoints.l} {
        // background: url(${publicPath('/images/desktop/club/map-placeholder.jpg')}) 0 0 no-repeat;
        background-size: cover;
        min-height: 184px;
        max-height: 184px;
      }
    `,
    detailsWrapper: css`
      padding-top: ${spacing.m};

      ${breakpoints.m} {
        grid-template-columns: auto;
      }
    `,
    locationDetailsWrapper: css`
      padding: 0;
      margin: -8px 0 0;
    `,
    addressStyles: css`
      padding-top: 12px;
      margin-bottom: 3rem;
    `,
    maplink: css`
      margin: ${spacing.s} 0;
      color: ${colors.navy};
      font-weight: normal;
      display: flex;
      align-items: center;
      ${breakpoints.s} {
        &:focus-visible {
        outline: none;
        border-bottom: 2px solid ${colors.border_black};
        color: ${colors.border_black};
        background-color: ${colors.skip_yellow};
        width: fit-content;
      }
      &:hover{
        text-decoration: underline;
        font-weight: bold;
      }
    }
    `,
  };
};